import { create } from "zustand";

export type BannerStatus = "loading" | "success" | "error";

export type Banner = {
  id: string;
  status: BannerStatus;
  message: string;
};

type State = {
  banners: Banner[];
};

type Actions = {
  push: (id: string, banner: Omit<Banner, "id">) => void;
  update: (id: string, partial: Partial<Omit<Banner, "id">>) => void;
  dismiss: (id: string) => void;
  clear: () => void;
};

export const useAsyncBanners = create<State & Actions>()((set) => ({
  banners: [],

  push: (id, banner) =>
    set((s) => {
      const exists = s.banners.some((b) => b.id === id);
      if (exists) {
        return {
          banners: s.banners.map((b) =>
            b.id === id ? { ...b, ...banner } : b,
          ),
        };
      }
      return { banners: [{ id, ...banner }, ...s.banners] };
    }),

  update: (id, partial) =>
    set((s) => ({
      banners: s.banners.map((b) => (b.id === id ? { ...b, ...partial } : b)),
    })),

  dismiss: (id) =>
    set((s) => ({ banners: s.banners.filter((b) => b.id !== id) })),

  clear: () => set({ banners: [] }),
}));
